import { Route } from '@angular/router';
import { setPasswordGuard } from '@ps/auth-data-access';
import { APP_ROUTE_PATHS } from '@ps/core-config';

/** Default authenticated landing segment; keep in sync with `app.routes` `redirectTo`. */
export const DEFAULT_AUTHENTICATED_ROUTE_PATH = APP_ROUTE_PATHS.dashboard;

/** Matches `APP_ROUTES.GUEST_ROUTES` — used under `guestGuard` + basic layout */
export const GUEST_ROUTES: Route[] = [
  {
    path: APP_ROUTE_PATHS.oidc,
    loadComponent: () =>
      import('../pages/auth/sso/sso.page').then((m) => m.SsoPage),
    title: 'Single Sign-On',
  },
  {
    path: APP_ROUTE_PATHS.login,
    loadComponent: () =>
      import('../pages/auth/login/login.page').then((m) => m.LoginPage),
    title: 'Log In',
  },
  {
    path: APP_ROUTE_PATHS.forgotPassword,
    loadComponent: () =>
      import('../pages/auth/forgot-password/forgot-password.page').then(
        (m) => m.ForgotPasswordPage,
      ),
    title: 'Forgot Password?',
  },
  {
    path: APP_ROUTE_PATHS.setPassword,
    canActivate: [setPasswordGuard],
    loadComponent: () =>
      import('../pages/auth/set-password/set-password.page').then(
        (m) => m.SetPasswordPage,
      ),
    title: 'Set Password',
  },
  {
    path: APP_ROUTE_PATHS.invalidPassword,
    loadComponent: () =>
      import(
        '../pages/status-pages/invalid-password-link/invalid-password-link.page'
      ).then((m) => m.InvalidPasswordLinkPage),
    title: 'Invalid Password Link',
  },
];
